module.exports = __webpack_public_path__ + "img/rio_de_janeiro.b36d7f45.jpg";